import { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
import { t } from '../../components/common/Translate';
import { Auth, recordActions } from '../../config/configuration/react';
import { checkIfSelectedDateExist, processDate } from '../../Store/helpers/pricing';
import { defaultProfile } from '../../config';
import { Record } from '../../config/Record/RecordEntity';

export const usePricingBloc = () => {
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const [reference, setReference] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [vinVersionsOpen, setVinVersionsOpen] = useState(false);
  const [message, setMessage] = useState({
    status: null,
    data: '',
  });
  const [packageNoaMessage, setPackageNoaMessage] = useState(null);
  const [packageNoaLoading, setPackageNoaLoading] = useState(null);
  const [tooltipOpenFirst, setTooltipOpenFirst] = useState(false);
  const [tooltipOpenSecond, setTooltipOpenSecond] = useState(false);
  const currentDate = new Date();
  const [isLoading, setIsLoading] = useState(false);
  let modelData;
  const [modelDataPackageNoa, setModelDataPackageNoa] = useState(null);
  const record = useSelector((state) => state.reduxRecords.data[recordId]);
  const recordEntity = new Record(record);
  const recordStatus = useSelector((state) => state.reduxRecords.data[recordId])?.record?.statusId;
  const coverage = useSelector((state) => state.reduxRecords.data[recordId]?.coverage || []);
  const userCarProfile = useSelector((state) => state.reduxRecords.data[recordId]?.userPricing?.carProfile || '');
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const supervisorProfile = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.profileVo);
  const [carProfile, setCarProfile] = useState(userCarProfile || supervisorProfile);
  const entryStockOptions = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption;
  const supervisorEntryStock = useSelector(
    (state) => state.reduxRecords.data[recordId]?.supervisor?.entryStockValue || 0,
  );
  const aiReport = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.aiReport);
  const automaticNoa = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.isEnableAutomaticNoaCall,
  );
  const { isEnablePackage } =
    useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData) || {};
  const inspectionVersion = useSelector((state) => state.reduxRecords.data[recordId]?.inspectionVersion);
  const monkReportStatus = useSelector((state) => state.reduxRecords.data[recordId]?.monkReportStatus || []);
  const monkReportData = useSelector((state) => state.reduxRecords.data[recordId]?.monkReportData || []);
  const caMonkReportStatus = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.monkReportStatus || [],
  );
  const caMonkReportData = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.monkReportData || [],
  );
  const monkInspectionVersion = useSelector(
    (state) => state.reduxRecords.data[recordId]?.monkReportStatus?.versionInspection || 0,
  );
  const counterInspectionVersion = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.version || 0,
  );
  const counterInspectionMonkVersion = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.monkReportStatus?.versionInspection || 0,
  );
  let supervisorEntryDate = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.entryStockDate?.date);
  const supervisorEntryDateFormatted =
    (supervisorEntryDate && moment(supervisorEntryDate).format('YYYY/MM/DD')) || false;
  supervisorEntryDate = (supervisorEntryDate && moment(supervisorEntryDate).format('DD/MM/YYYY')) || false;
  if (supervisorEntryDate && checkIfSelectedDateExist(entryStockOptions, supervisorEntryStock, supervisorEntryDate))
    supervisorEntryDate = false;
  const [entryStockSelectedKey, setEntryStockSelectedKey] = useState(
    (supervisorEntryDate && 'selected') || supervisorEntryStock,
  );
  let sourceProfileLabels = defaultProfile;
  const sourceProfile = useSelector((state) => state.reduxRecords.data[recordId])?.sourceInfos?.profiles;
  const counterInspectionRecordId = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.recordId,
  );

  if (sourceProfile !== null && sourceProfile?.length > 0) {
    sourceProfileLabels = sourceProfile.map((a) => a.profile);
  }
  const updateUserPricing = (data) => {
    dispatch(recordActions.updateUserPricing(data));
  };

  useEffect(() => {
    if (entryStockSelectedKey === 'selected') {
      let entryStockDateDefault = supervisorEntryDateFormatted;
      let entryStockKeyDefault = supervisorEntryStock;
      if (
        supervisorEntryDate &&
        processDate(supervisorEntryDate) > processDate(moment(currentDate).format('DD/MM/YYYY')) &&
        !recordEntity.isHBS()
      ) {
        entryStockDateDefault = moment(currentDate).format('YYYY/MM/DD');
        entryStockKeyDefault = entryStockSelectedKey;
      }
      updateUserPricing({ entryStockDate: entryStockDateDefault, entryStockKey: entryStockKeyDefault });
    }
    if (entryStockOptions) {
      entryStockOptions.forEach((i) => {
        if (_.get(i, entryStockSelectedKey))
          updateUserPricing({ entryStockDate: _.get(i, entryStockSelectedKey), entryStockKey: entryStockSelectedKey });
      });
    }
  }, [entryStockSelectedKey]);

  const onChange = (e) => {
    const { id, value } = e.target;
    if (id === 'entryStockDays') setEntryStockSelectedKey(value);
  };

  const history = useHistory();
  const toggle = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    if (!isOpen) {
      setModelDataPackageNoa(null);
      setPackageNoaMessage(null);
    }
  }, [isOpen]);
  const postReportAi = (CountrInspection) => {
    history.push(`/files/${recordId}`);
    if (!CountrInspection) dispatch(recordActions.postReportAi(recordId));
    if (CountrInspection) dispatch(recordActions.postReportAi(counterInspectionRecordId, recordId));
  };
  const handleMonkReport = () => {
    if (isEnablePackage) {
      setPackageNoaLoading(true);
      recordActions
        .getPackageMonkGenerate(recordStatus !== 40 ? recordId : counterInspectionRecordId)
        .then((res) => {
          const { data } = res || {};
          if (data?.limitReached === true && data?.alreadySaved === false) {
            setIsOpen(true);
            setModelDataPackageNoa({
              type: 'noaPackage',
              closeIcon: true,
              body: {
                className: 'package-noa-padding',
              },
              footer: {
                className: 'justify-content-center',
                btn: {
                  onClick: toggle,
                  name: t('cancel'),
                  id: 'cancel',
                },
                btn2: {
                  onClick: () => postReportAi(recordStatus === 40),
                  name: t('continuePopupNoa'),
                  id: 'continuePopupNoa',
                  notDisable: true,
                },
              },
            });
            if (data?.excessClicksCount === 0)
              setPackageNoaMessage([
                t('popupNoaPackage1')?.replace('X', data?.maxAllowedRecords || ''),
                t('popupNoaPackage2'),
                t('popupNoaPackage3'),
              ]);
            if (data?.excessClicksCount > 0)
              setPackageNoaMessage([
                t('popupNoaPackage1')?.replace('X', data?.maxAllowedRecords || ''),
                `${t('popupNoaPackage2')} ${t('popupNoaPackage4')?.replace('X', data?.excessClicksCount || '')}`,
                t('popupNoaPackage3'),
              ]);
          } else postReportAi(recordStatus === 40);
        })
        .finally(() => setPackageNoaLoading(false));
    } else {
      postReportAi(recordStatus === 40);
    }
  };
  const handleMonkReportForCA = () => {
    history.push(`/files/${recordId}`);
    dispatch(recordActions.postReportAi(counterInspectionRecordId, recordId));
  };

  const handleMonkReportAuto = async () => {
    setIsLoading(true);
    try {
      await dispatch(recordActions.postReportAi(recordId));
    } finally {
      setIsLoading(false);
    }
  };

  const handleMonkReportAutoForCA = async () => {
    setIsLoading(true);
    try {
      await dispatch(recordActions.postReportAi(counterInspectionRecordId, recordId));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateUserPricing({ carProfile });
  }, [carProfile]);

  const formatCoverage = (body) => {
    if (body && body.length === 0) return { data: false, showBtn: true };
    const afterFormat = { data: { ...body } };
    const { authorization, expired } = afterFormat.data;

    switch (authorization?.toLowerCase()) {
      case 'y':
        if (expired) _.set(afterFormat.data, 'authorization', 'guaranteedPriceExpired');
        else _.set(afterFormat.data, 'authorization', 'guaranteedPriceAccepted24');
        afterFormat.data.showEndValidateDate = true;
        afterFormat.showBtn = true;
        break;
      case 'n':
        _.set(afterFormat.data, 'authorization', 'guaranteedPriceRefused');
        afterFormat.data.showEndValidateDate = false;
        afterFormat.showBtn = false;
        break;
      default:
        afterFormat.showBtn = true;
        break;
    }
    return afterFormat;
  };

  const reintialise = () => {
    setReference('');
    setMessage({
      status: null,
      data: '',
    });
  };

  const handleClick = async () => {
    setIsLoading(true);
    const res = await dispatch(recordActions.postFordCoverage(recordId, { reference }));
    setMessage(res);
    setIsLoading(false);
  };

  if (!modelData) {
    switch (message.status) {
      case 201:
        modelData = {
          title: t('confirmationGuaranteedPriceTitle'),
          body: {
            input: false,
            message2: t('confirmationGuaranteedPriceMessage'),
          },
          footer: {
            btn2: {
              onClick: toggle,
              name: t('close'),
            },
          },
        };
        break;
      default:
        modelData = {
          title: `${t('fillGuaranteedPricePopUp')} :`,
          body: {
            input: true,
            onChange: (e) => {
              if (e.target.value === '') reintialise();
              setReference(e.target.value);
            },
          },
          footer: {
            className: 'justify-content-center',
            btn: {
              onClick: toggle,
              name: t('cancel'),
              id: 'cancel',
            },
            btn2: {
              onClick: handleClick,
              name: t('validate'),
              id: 'validate',
            },
          },
        };
        break;
    }
  }

  return {
    isLoading,
    isOpen,
    toggle,
    modelData,
    message,
    coverage: formatCoverage(coverage),
    reference,
    permissionFord: Auth.isAllowedToAccessFord(),
    entryStockOptions,
    carProfile: userCarProfile,
    setCarProfile,
    entryStockSelectedKey,
    supervisorEntryDate,
    supervisorEntryStock,
    onChange,
    sourceProfileLabels,
    aiReport,
    automaticNoa,
    handleMonkReport,
    handleMonkReportAuto,
    monkReportStatus,
    monkReportData,
    inspectionVersion,
    tooltipOpenFirst,
    setTooltipOpenFirst,
    tooltipOpenSecond,
    setTooltipOpenSecond,
    monkInspectionVersion,
    originId,
    vinVersionsOpen,
    setVinVersionsOpen,
    handleMonkReportForCA,
    counterInspectionVersion,
    counterInspectionMonkVersion,
    caMonkReportStatus,
    caMonkReportData,
    handleMonkReportAutoForCA,
    recordStatus,
    packageNoaMessage,
    modelDataPackageNoa,
    packageNoaLoading,
    isNrmRecord: recordEntity.isNrmRecord(),
  };
};
